import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputDateComponent from "presentation/components/Shared/InputDateComponent";
import InputTextAreaComponent from "presentation/components/Shared/InputTextAreaComponent";
import InputTextComponent from "presentation/components/Shared/InputTextComponent";
import { useClientStore } from "presentation/stores/use-client-store";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { useProjectStore } from "presentation/stores/use-project-store";
import './index.css';
import { useEffect, useState } from "react";

const ProjectInfoForm = () => {
  const { project, setProject } = useProjectStore();
  const { projectStatus } = useParameterStore();
  const { client } = useClientStore();

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (visible) timer = setTimeout(() => setVisible(false), 3000);
    return () => clearTimeout(timer);
  }, [visible]);

  return (
    <div className="default-grid ">
      <div className="default-1-col">
        <InputTextComponent
          label="Nome"
          fieldName="name"
          currentObject={project}
          getValue={project?.name}
          setValue={setProject}
        />
      </div>
      <div className="default-1-col">
        <InputDateComponent
          label="Data de início"
          fieldName="startAt"
          currentObject={project}
          getValue={project?.startAt}
          setValue={setProject}
        />
      </div>
      <div className="default-1-col">
        <InputDateComponent
          label="Data de término"
          fieldName="endAt"
          currentObject={project}
          getValue={project?.endAt}
          setValue={setProject}
          />
        <div className="input-wrapper">
          <button className="info-btn" onClick={() => setVisible(true)}>i</button>
          {visible && (
            <div className="tooltip-modal show">
              A data de término de todos os colaboradores deve ser igual ou anterior à data de término do projeto.
            </div>
          )}
        </div>
      </div>

      <div className="default-1-col">
        <InputTextComponent
          label="Status"
          fieldName="status"
          currentObject={project}
          getValue={project?.status}
          setValue={setProject}
          isDisable={true}
        />
      </div>

      <div className="default-4-cols">
        <DropdownComponent
          options={client}
          label="Cliente"
          fieldName="client"
          isValueId={true}
          currentObject={project}
          getValue={project?.client.id}
          setValue={setProject}
          isDisable={!!project?.id}
        />
      </div>

      <div className="default-4-cols">
        <InputTextAreaComponent
          label="Descrição"
          fieldName="description"
          currentObject={project}
          getValue={project?.description ? project?.description : ""}
          setValue={setProject}
        />
      </div>
    </div>
  );
};

export default ProjectInfoForm;
